import {cssClasses, strings} from '@material/list/constants';

/**
 * As of v2 they stopped checking disabled items
 * I can understand this from an accessibility standpoint, in a world where disabled items are visible
 * but in our theme we hide disabled list tiems from the user
 * @function
 * @param {MDCList} list Instance of mdc-list
 */
export const arrowNavigationPatch = (list) => {
	// Do not patch twice
	if (!list || list.arrowNavaigationPatched_) return;

	list.arrowNavaigationPatched_ = true;

	const foundation = list.foundation_;

	foundation.focusPrevElement = _.wrap(
		foundation.focusPrevElement,
		(focusPrevElement, index) => {
			let prevIndex = index - 1;
			if (prevIndex < 0) {
				// Return early because first item is already focused.
				if (!foundation.wrapFocus_) return index;
				prevIndex = foundation.adapter_.getListItemCount() - 1;
			}

			// Skip disabled items
			const listItemEl = list.listElements[prevIndex];
			if (
				listItemEl &&
				listItemEl.classList.contains(cssClasses.LIST_ITEM_DISABLED_CLASS)
			) {
				return foundation.focusPrevElement(prevIndex);
			}

			// Carry on
			return focusPrevElement.call(foundation, index);
		},
	);

	foundation.focusNextElement = _.wrap(
		foundation.focusNextElement,
		(focusNextElement, index) => {
			const count = foundation.adapter_.getListItemCount();
			let nextIndex = index + 1;
			if (nextIndex >= count) {
				// Return early because last item is already focused.
				if (!foundation.wrapFocus_) return index;
				nextIndex = 0;
			}

			// Skip disabled items
			const listItemEl = list.listElements[nextIndex];
			if (
				listItemEl &&
				listItemEl.classList.contains(cssClasses.LIST_ITEM_DISABLED_CLASS)
			) {
				return foundation.focusNextElement(nextIndex);
			}

			// Carry on
			return focusNextElement.call(foundation, index);
		},
	);
};

/**
 * https://github.com/material-components/material-components-web/issues/4696
 * @function
 * @param {MDCList} list MDCList
 */
export const disabledListItemCheckboxPatch = (list) => {
	// Do not patch twice
	if (!list || list.disabledListItemCheckboxPatched_) return;

	list.prototype.initializeListType = _.wrap(
		list.prototype.initializeListType,
		function (initializeListType) {
			const foundation = this.foundation_;
			const adapter = foundation.adapter_;

			adapter.setCheckedCheckboxOrRadioAtIndex = (index, isChecked) => {
				const listItem = this.listElements[index];
				const toggleEl = listItem.querySelector(
					strings.CHECKBOX_RADIO_SELECTOR,
				);
				// This is all this was overriden for
				if (!toggleEl) return;

				toggleEl.checked = isChecked;
				const event = document.createEvent('Event');
				event.initEvent('change', true, true);
				toggleEl.dispatchEvent(event);
			};

			return initializeListType.call(this);
		},
	);
};
